import React from "react";
import { Input, Textarea, Radio } from "../../";
import locales from "../../../constants";

const SecondStep = ({ register, errors, step, setStep, lang }) => {
  const translation = locales[lang];
  return (
    <div
      className="step_2 stepWrapper"
      style={{ display: step === 2 ? "block" : "none" }}
    >
      <h3 className="step-title">
        {translation.brief_campaign.step_2_main_header}
      </h3>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_campaign.step_2_company_profile_header}</h4>
          <p>{translation.brief_campaign.step_2_company_profile_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Input
            type="text"
            name="company_profile"
            label={translation.brief_campaign.step_2_company_profile_label}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_campaign.step_2_target_group_header}</h4>
          <p>{translation.brief_campaign.step_2_target_group_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Input
            type="text"
            name="target_group"
            label={translation.brief_campaign.step_2_target_group_label}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_campaign.step_2_competition_header}</h4>
          <p>{translation.brief_campaign.step_2_competition_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Textarea
            type="text"
            name="competition"
            label={translation.brief_campaign.step_2_competition_label}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_campaign.step_2_unique_features_header}</h4>
          <p>{translation.brief_campaign.step_2_unique_features_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Textarea
            type="text"
            name="unique_features"
            label={translation.brief_campaign.step_2_unique_features_label}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_campaign.step_2_comunication_header}</h4>
          <p>{translation.brief_campaign.step_2_comunication_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Textarea
            type="text"
            name="comunication"
            label={translation.brief_campaign.step_2_comunication_label}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_campaign.step_2_social_media_header}</h4>
          <p>{translation.brief_campaign.step_2_social_media_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Textarea
            type="text"
            name="social_media"
            label={translation.brief_campaign.step_2_social_media_label}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_campaign.step_2_work_area_header}</h4>
          <p>{translation.brief_campaign.step_2_work_area_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Textarea
            type="text"
            name="work_area"
            label={translation.brief_campaign.step_2_work_area_label}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_campaign.step_2_expansion_header}</h4>
          <p>{translation.brief_campaign.step_2_expansion_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <div className="row">
            <div className="col-sm-12">
              <Radio
                name="expansion"
                id="expansion_yes"
                label={translation.brief_campaign.step_2_expansion_label_1}
                register={register}
                errors={null}
              />
            </div>
            <div className="col-sm-12">
              <Radio
                name="expansion"
                id="expansion_no"
                label={translation.brief_campaign.step_2_expansion_label_2}
                register={register}
                errors={null}
              />
            </div>
            <div className="col-sm-12">
              <Radio
                name="expansion"
                id="expansion_plan"
                label={translation.brief_campaign.step_2_expansion_label_3}
                register={register}
                errors={null}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_campaign.step_2_seasons_header}</h4>
          <p>{translation.brief_campaign.step_2_seasons_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Textarea
            type="text"
            name="seasons"
            label={translation.brief_campaign.step_2_seasons_label}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="btn-brief-group">
        <button
          type="button"
          className="btn_brief stepWrapperBtn"
          onClick={() => setStep(1)}
        >
          {translation.brief_campaign.step_1_prev_step}
        </button>
        <button
          className="btn_brief stepWrapperBtn"
          type="button"
          onClick={() => setStep(3)}
        >
          {translation.brief_campaign.step_1_next_step}
        </button>
      </div>
    </div>
  );
};

export default SecondStep;
